import { Button as AntButton, Modal } from "antd";
import { FC, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { getClassesAssignment } from "../../../../../../api/campusClasses.api";
import { createStudent } from "../../../../../../api/campusClasses2.api";
import { getSemesterCourses, getSemesters } from "../../../../../../api/semesters.api";
import useAxios from "../../../../../../hooks/useAxios";
import { IClassAssignmentQuery, IGetClassAssignment } from "../../../../../../models/campusClasses.model";
import { IGetSemesterCourses, IGetSemesters } from "../../../../../../models/semesters.model";
import ErrorResponse from "../../../../../ErrorResponse";
import Loader from "../../../../../Loader";
import ClassAssignmentContents from "../../../../../student/student/class/ClassAssignmentContents";

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  data: any;
  doGetExamineeDetail: (platRequireCode: number) => void;
  eduStepCode: string;
}

const AssignClassModal: FC<IProps> = ({
  visible,
  setVisible,
  data,
  doGetExamineeDetail,
  eduStepCode,
}) => {
  const { t } = useTranslation();
  const { data: res, isLoading, error, execute } = useAxios<IGetClassAssignment>();
  const { data: res2, isLoading: isLoading2, error: error2, execute: execute2 } = useAxios<IGetSemesters>();
  const { data: res3, isLoading: isLoading3, error: error3, execute: execute3 } = useAxios<IGetSemesterCourses>();
  const { data: submitRes, isLoading: submitIsLoading, error: submitError, execute: submitExecute } = useAxios();

  useEffect(() => {
    if (data?.baseInfo?.memberCode) {
      // execute(getClassesAssignment(data.baseInfo.campusCode));
      execute2(getSemesters());
    }
  }, [data]);

  useEffect(() => {
    if (submitRes) {
      if (data?.baseInfo?.platRequireCode) {
        doGetExamineeDetail(data.baseInfo.platRequireCode);
      }
    }
  }, [submitRes]);

  const doGetSemesterCourses = (semesterCode: string) =>
    execute3(getSemesterCourses(semesterCode));

  const onSearch = (params?: IClassAssignmentQuery) => {
    if (!data) return;
    execute(getClassesAssignment(data.baseInfo.campusCode, {
      ...params,
      eduStepCode,
    }));
  };

  const onSubmit = (classCode: string, studySrtDate: string, timetableCode: number) => {
    data &&
      submitExecute(
        createStudent(classCode, {
          studentCode: data.baseInfo.memberCode,
          studySrtDate,
          srtTimetableCode: timetableCode,
        }),
      );
  };

  return (
    <>
      {(isLoading || isLoading2 || isLoading3 || submitIsLoading) && <Loader />}
      <ErrorResponse error={error} />
      <ErrorResponse error={error2} />
      <ErrorResponse error={error3} />
      <ErrorResponse error={submitError} />
      <Modal
        title={t('entrance.schedule.title12')}
        visible={visible}
        onCancel={() => setVisible(false)}
        width={750}
        footer={[
          <div className='comm-btn__area justify-content-center'>	
            <AntButton
              key="cancel"
              className='btn-basic gray'
              onClick={() => setVisible(false)}
            >
              {t('common.button.close')}
            </AntButton>
          </div>
        ]}
      >
        <ClassAssignmentContents
          data={res?.data}
          semesterList={res2?.data}
          semesterCourseList={res3?.data}
          onSearch={onSearch}
          onSubmit={onSubmit}
          doGetSemesterCourses={doGetSemesterCourses}
          eduStepCode={eduStepCode}
        />        
      </Modal>
    </>
  );
}

export default AssignClassModal;
